import { apiClient } from "./apiClient";

export const equipmentApi = {
  list: () => apiClient.get("/equipment/inventory").then((r) => r.data),
  add: (payload) => apiClient.post("/equipment/inventory", payload).then((r) => r.data),
  logMaintenance: (payload) => apiClient.post("/equipment/maintenance", payload).then((r) => r.data),
  reorder: () => apiClient.get("/equipment/reorder").then((r) => r.data),
  // Owned / needs repair / out on hives / available, from one calculation
  // (V074). The list used to show `quantity` -- how many you OWN -- under
  // a heading people read as "how many I can use".
  stock: () => apiClient.get("/equipment/stock").then((r) => r.data),
  // Bought more, lost some, broke some, fixed some. Writes a movement
  // rather than editing a number, so the count can always be explained.
  adjust: (payload) => apiClient.post("/equipment/adjust", payload).then((r) => r.data),

  /*
   * Fold two names for one piece of kit together (#299).
   *
   * Two ids and nothing else -- the survivor keeps its own name,
   * threshold, supplier and cost. Merging is not the place to rename
   * things: doing both at once makes a mistake in either harder to see
   * and harder to explain afterwards.
   */
  merge: (keepEquipmentId, mergeEquipmentIds) =>
    apiClient.post("/equipment/merge", {
      keep_equipment_id: keepEquipmentId,
      // SEVERAL (#409). Duplicates arrive in clusters -- "Frame",
      // "Frames", "frame " -- and folding them one pair at a time made
      // the user re-choose the survivor once per stray spelling.
      //
      // concat rather than a bare array so one id still works: the
      // server answers per item either way, and a caller passing a
      // single number is not a caller who should get a silent [5] ->
      // [[5]] and a validation error about it.
      merge_equipment_ids: [].concat(mergeEquipmentIds),
    }).then((r) => r.data),
  assignments: () => apiClient.get("/equipment/assignment").then((r) => r.data),
  // Assigning does NOT decrement inventory: quantity is how many you own,
  // and what is deployed is derived from open assignments (#250).
  assign: (payload) => apiClient.post("/equipment/assignment", payload).then((r) => r.data),
  returnItem: (assignmentId, payload) =>
    apiClient.post(`/equipment/assignment/${assignmentId}/return`, payload || {}).then((r) => r.data),
};
